import React ,{useEffect , useRef, useState} from 'react';
import TabComponent from './TabComponent/TabComponent';
import TabComponentHeader from './TabComponent/TabComponentHeader';
// import BuildingCanvas from './BuildingCanvas/BuildingCanvas';
import NewCanvas from './Canvas/NewCanvas';
import SumBar from './Common/SumBar';
import NextPrevFooter from './Common/NextPrevFooter';
import ProductSummary from './Common/ProductSummary';
import SlideImage from './Common/SlideImage';
import GatherCustomerInformation from './Common/GatherCustomerInformation';
import Checkout from './Checkout/Checkout';
import { useSelector, useDispatch } from 'react-redux';
import SaveandQuote from './Common/SaveAndGetQuote';
import DownloadProgressBar from './Common/DownloadProgressBar';
import { ShowCustomizeBuilding, setIsMobile } from '../action';
import BuildingImage from './Common/BuildingImage';
import BuildingInformation from './Common/BuildingInformation';
import { const_var } from '../redux/reducers/reducer';
import MobileHeader from './MobileComponents/MobileHeader';
import BuildingAction from './Common/BuildingAction';
import { moreDetail,getBuildingDataforProduct, showDownloadProgressBar, ShowMobilePopUp} from '../action';
import Thank from './Common/ThankYou';
import SaveThank from './Common/SaveThank';
import DoorWindowIcons from './TabComponent/DoorWindows/DoorWindowIcons';
import DoorWindowEditBox from './TabComponent/DoorWindows/DoorWindowEditBox';
import CustomizeYourBuilding from './MobileComponents/CustomizeYourBuilding';
import MobileBuildingStart from './MobileComponents/MobileBuildingStart';
import Share from './Common/Share';
import CustomAlertBox from './Common/CustomAlertBox';
import location_icon from '../assets/images/mobile-images/position/position.svg'
import building_arrow from '../assets/images/arrow/viewBuildingArrow.svg'
import Savelater from './Modals/SaveLater';
import { onResize } from '../redux/reducers/componentReducer';

import Draggable from 'react-draggable'
import { controls } from '../redux/reducers/eventReducer';
import PaymentError from './Common/PaymentError';

const Component = ()=> {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.reducer)
    const detail = state.const_var.isShowMoreDetail;
    let isShowConfigBox = useSelector(state => state.reducer.const_var.isShowConfigBox);
    const isShowThankYou = useSelector(state => state.orderReducer.isShowThankYou);
    const [isBlink, setBlink] = useState(true);
    
    useEffect(()=>{
        const activescroll = document.querySelector('.config-option-sec-inner-scroll');
        if (activescroll?.scrollHeight > activescroll?.clientHeight) {
            activescroll?.classList.add('activescroll');
        } else {
            activescroll?.classList.remove('activescroll');
        }
        
    },[controls.isCheckActiveTab])

    // sticky functionality
    const stickyElementRef = useRef(null);
    const containerRef = useRef(null);
    const headRef = useRef(null);
    const draggableEntity = useRef({x: 0 , y: 0});
    useEffect(() => {
        const handleScroll = () => {
            if(window.innerWidth <= 992) return;
            const top = window.innerWidth < 1280 ? 35: 40;
            const headHeight = headRef.current.getBoundingClientRect().height-top;
            const tabChild = stickyElementRef.current.children[1].children[0].children[0].children[0].children[3]
            if (window.scrollY > headHeight ) {
                if(containerRef!=null && containerRef.current){
                    containerRef.current.style.transition = 'margin-top 0.3s ease';
                    if(window.scrollY - headHeight > top) {
                        containerRef.current.style.marginTop = top+'px';
                    }else {
                        containerRef.current.style.marginTop = (window.scrollY - headHeight)+'px';
                    }
                }
                stickyElementRef.current.style.borderTopLeftRadius = '0px'
                stickyElementRef.current.style.borderTopRightRadius = '0px'
                if(tabChild!=undefined) tabChild.style.borderTopRightRadius = '0px'
            } else {
                if(containerRef!=null && containerRef.current){
                    containerRef.current.style.transition = 'margin-top 0.3s ease';
                    containerRef.current.style.marginTop = '0px';
                }
                stickyElementRef.current.style.borderTopLeftRadius = '6px'
                stickyElementRef.current.style.borderTopRightRadius = '6px'
                if(tabChild!=undefined) tabChild.style.borderTopRightRadius = '5px'
            }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    }, [state.const_var.editAPIDataByResponse.data]);

    const downloadPdf = () => {
        if(!state.const_var.isShowDownloadProgressBar) {
            dispatch(showDownloadProgressBar("show"))
        }
    }

    const handleResize = () => {
        if(window.innerWidth <= 992) {
            dispatch(setIsMobile(true))
        } else {
            dispatch(setIsMobile(false))
        }
    }


    const initializeSize = () => {
        if(state.showThumb == false){
            let area = (window.innerHeight * 50 / 100) * window.innerWidth/2
            console.log(area,"area")
            document.getElementsByClassName("building-size")[0].style.height = `${parseInt(Math.sqrt(area))}px` 
            document.getElementsByClassName("building-size")[0].style.width = `auto`
            // onResize();
        }
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        if(document.getElementsByClassName("building-size")[0].style.height !== "110px"){
            initializeSize()
        }
        if(window.innerWidth > 992){
            dispatch(ShowCustomizeBuilding("show","resetThumb"))
        }
        return () => {
            window.removeEventListener('resize', handleResize);
            hideZoom(false)
        };
    }, [window.innerWidth]);   
    
    useEffect(() => {
        if(state.showThumb == false){
            handleResize()
            // setTimeout(function(){    
            //     onResize();
            // }, 400)
        }
    },[window.innerWidth]);


    const [position, setPosition] = useState({ x: 0, y: 0 }); //to manage the thumb drag position

    const [arrowLeft, setArrowPosition] = useState(true) //manage for left and right arrow

    const [zoom , hideZoom] = useState(false) //to show the right icon on thumb

    const handleDrag = (e, ui) => { //this function is working on Drag
      const { x, y } = position;
      document.getElementById("canvas-container").style.transition = "inherit";
      document.getElementById("carport-canvas").style.transition = "inherit";
      hideZoom(true)
    };

    const showThumb = (e) => { // on left and right button click this function is calling
        let from = document.getElementsByClassName("thumb-wrapper")[0].classList.value.includes("active-arrow-right")
        if(from){
            //remove the right arrow class from thumb
            document.getElementsByClassName("thumb-wrapper")[0].classList.remove("active-arrow-right");
            setPosition({x: position.x  - 150 - 15, y: position.y})
        }else{
            //remove the Left arrow class from thumb
            document.getElementsByClassName("thumb-wrapper")[0].classList.remove("active-arrow-left");
            setPosition({x: position.x + 150 + 15, y: position.y})
        }
    }

    const handleStop = (e, data) => { //this function is working on stop Drag
        let innerWidth = window.innerWidth
        let innerHeight = window.innerHeight
        let x = draggableEntity.current.state.x
        let y = draggableEntity.current.state.y
        document.getElementById("canvas-container").style.transition = "all 0.3s ease-in 0s";
        document.getElementById("carport-canvas").style.transition = "all 0.3s ease-in 0s";
        if(draggableEntity.current !== undefined){
            setPosition({ x: x , y: y });
        }
        if(innerWidth + (x - 150 -15) < 5){ //left Side 
            document.getElementsByClassName("thumb-wrapper")[0].classList.add("active-arrow-left");
            setPosition({x: -innerWidth + 15 , y: y})
            setArrowPosition(true)
        }else if( x > 0){ //Right Side
            document.getElementsByClassName("thumb-wrapper")[0].classList.add("active-arrow-right");
            setPosition({x: 150 + 15 , y: y})
            setArrowPosition(false)
        }else if( innerHeight + (y - 110) < 5 ){ //Top Side
            setPosition({ x: x , y: -innerHeight + 110 + 30 })
        }else if( y > 15){ //Bottom Side
            setPosition({x: x , y: 0})
        }
        if(innerWidth + (x - 150 -15) < 5 && innerHeight + (y - 110) < 5){ //Left and Top Side
            document.getElementsByClassName("thumb-wrapper")[0].classList.add("active-arrow-left");
            setPosition({x: -innerWidth + 15 , y: -innerHeight + 110 + 30})
            setArrowPosition(true)
        }
        if(innerWidth + (x - 150 -15) < 5 && y > 15){ //Left and Bottom Side
            document.getElementsByClassName("thumb-wrapper")[0].classList.add("active-arrow-left");
            setPosition({x: -innerWidth + 15 , y: 0})
            setArrowPosition(true)
        }
        if( x > 0 && innerHeight + (y - 110) < 5){ //Right and Top Side
            document.getElementsByClassName("thumb-wrapper")[0].classList.add("active-arrow-right");
            setPosition({x: 150 + 15 , y: -innerHeight + 110 + 30})
            setArrowPosition(false)
        }
        if( x > 0 && y > 15){ //Right and Bottom
            document.getElementsByClassName("thumb-wrapper")[0].classList.add("active-arrow-right");
            setPosition({x: 150 + 15 , y: 0})
            setArrowPosition(false)
        }
        hideZoom(false)
      };

    return (
        <>  
           <div className={ !state.isMobile ? 'desktop-container':'mobile-container'}>           
                <div className={(isShowConfigBox ? '':'d-none')}>
                    {!state.isMobile ?
                        <div className='head-container' ref={headRef}>
                            <div className='container d-flex'>
                                <BuildingInformation />
                                <BuildingImage />
                            </div>
                            
                        </div>
                        : <MobileHeader />
                    }
                    <div className= { !state.isMobile ? 'content-container' : state.showThumb ? 'thumb-wrapper-carport' : "" } id="header-scroll-to-top">
                        {!state.isMobile ?
                            <>
                                <div className= "head">
                                    <div className='container'>
                                        <div className='component-wrapper'>
                                            <div className='component-wrapper-inner'>
                                                <div className='head-wrap'>
                                                    <div className='head-footer' ref={stickyElementRef} >
                                                        <div className='left-footer'>
                                                            <div className='customize-note'>
                                                                <h2>Customize Your Building</h2>
                                                                <span>Pick your installation state for accurate pricing</span>
                                                            </div>
                                                            <div className='state-container'>
                                                                <img src={location_icon} alt='location_icon' />
                                                                <div className={`select-state select ${isBlink? 'animation-pulse' : ''}`} >
                                                                    <select onClick={()=>setBlink(false)} value={state.params.p_s_n} onChange={(e) => dispatch(getBuildingDataforProduct(e.target.value,"state"))}>
                                                                        {
                                                                            const_var.bjDData.map((item) => {
                                                                                return <option value={item.id}>{item.state_name}</option>
                                                                            })
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='right-footer'>
                                                            <TabComponentHeader />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='right-background'></div>
                            </>
                        :null}
                        <div className='container' ref={state.isMobile ? containerRef:null}>
                            <div className='component-wrapper'>
                                <div className='component-wrapper-inner'>
                                    <div className='confige-wrapper'>
                                        <div className={!state.isMobile ?'config-building-sec right-sec-scoll':'config-building-sec '}>
                                            {!state.isMobile ?
                                                <div className='add-control'>
                                                    <BuildingAction />
                                                    <div className='more-details'>
                                                        <span className='d-flex' onClick={(e)=> dispatch(moreDetail("show"))}>{'View Building Summary'}<img className='ml-5' src={building_arrow} alt='right_arrow'/></span>
                                                    </div>
                                                </div>
                                            :null}
                                            <div className="thumb-wrapper" id="double-tap"> 
                                            <Draggable
                                                onDrag={handleDrag}
                                                ref={draggableEntity}
                                                position={position}
                                                disabled={state.showThumb === true ? false : true}
                                                onStop={handleStop}
                                                cancel="#for-full-view-click , #for-sticky-thumb"
                                            >
                                                <div
                                                    id="carport-canvas"
                                                    className={state.const_var.orderSaveForm == true && state.showThumb == true ? "d-none" : "building-canvas-inner"}
                                                    style={
                                                        state.showThumb
                                                            ? {
                                                                width: "150px",
                                                                height: "110px",
                                                                right: "15px",
                                                                bottom: "15px",
                                                                position: "fixed",
                                                                zIndex: "999",
                                                                borderRadius: "8px",
                                                                boxShadow: "0px 0px 30px #00000066",
                                                            }
                                                            : null
                                                    }
                                                >
                                                    {state.showThumb ? (
                                                        <>
                                                        {
                                                            !zoom 
                                                                ?
                                                                    <a
                                                                        id="for-full-view-click"
                                                                        className="exit-full-view"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setPosition({x: 0 ,y:0})
                                                                            dispatch(ShowCustomizeBuilding("show", "resetThumb"));
                                                                        }}
                                                                    >
                                                                        <span class="ico-icon-fullscreen icon"></span>
                                                                    </a>
                                                                :
                                                                    null
                                                        }
                                                         <a 
                                                            id="for-sticky-thumb"
                                                            className="arrow-out"
                                                            onClick={(e) => showThumb(e)}
                                                            >
                                                                <span className={arrowLeft ? "ico-icon-next icon" : "ico-icon-back icon"}></span>
                                                        </a>
                                                         </>
                                                    ) : null}
                                                    
                                                    <div
                                                        className="building-size"
                                                        style={
                                                            state.isMobile
                                                                ? {
                                                                    height:
                                                                        window.innerHeight -
                                                                        (state.const_var.isShowSaveQuote ? 362 : 373) +
                                                                        "px",
                                                                }
                                                                : null
                                                        }
                                                    >
                                                        {/* <BuildingCanvas
                                                            handleClickAction={(e) =>
                                                                dispatch({
                                                                    type: "UPDATE_DOOR_WINDOW_EDIT_ICONS",
                                                                    event: e,
                                                                })
                                                            }
                                                        /> */}
                                                        {
                                                            state.showThumb === false 
                                                            ?
                                                                <div className="doorwindowicons-1">
                                                                    <div id="doorwindowicons">
                                                                        <DoorWindowIcons />
                                                                    </div>
                                                                </div>
                                                            :
                                                            null    
                                                        }
                                                        <NewCanvas />
                                                       {const_var.showComponentEditBox && <DoorWindowEditBox />}
                                                    </div>
                                                </div>
                                            </Draggable>
                                            </div>
                                        </div>
                                        {!state.isMobile ?
                                            <div id="inner-div-scroll" className={window.innerWidth > 992 ? 'config-option-sec pb-0' : 'config-option-sec' }>
                                                <div className='config-option-sec-inner'>
                                                    <div className='config-option-sec-inner-scroll'>
                                                        <TabComponent/>
                                                    </div>
                                                </div>
                                                <div className={window.innerWidth > 1280 ? 'sticky-footer'  : "" } ><NextPrevFooter/></div>
                                            </div>
                                        :null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {state.isMobile ? (state.isCustomizeBuilding ? <CustomizeYourBuilding/> : <MobileBuildingStart />) :null}
                        {!state.const_var.isShowSaveQuote ? (<div className='sum-container'><SumBar /></div>) : (<div className='sum-container'><SaveandQuote /></div>)}
                    </div>
                </div>
                { detail && 
                    <div className='component-summary' onClick={(e)=> dispatch(moreDetail("hide"))}>
                        <div className={`product-summary-wrapper ${detail ? 'show' : 'hide'}`} onClick={e=>e.stopPropagation()}>
                            <span className='close'  onClick={(e)=> dispatch(moreDetail("show"))}>&times;</span>
                            <h2 className='heading1 '>Building Summary:</h2>
                            <ProductSummary />
                        </div>
                    </div>
                }
            </div>  
              
            <CustomAlertBox/>
            <PaymentError/>
            {state.const_var.isShowSaveThankBox && state.const_var.crmSetting.main_domain_url != "probuiltsteel.com" && <SaveThank/>}
            {state.const_var.isShowShare && <Share />}
            {state.const_var.isShowThankBox && state.const_var.crmSetting.main_domain_url != "probuiltsteel.com" && <Thank download={downloadPdf}/> }
             <GatherCustomerInformation download={downloadPdf} />      
             <Savelater />
            <div className={`${isShowThankYou ? 'd-none': (isShowConfigBox ? 'd-none':'container')}`}>
                <Checkout/>
            </div>
            {state.const_var.isShowDownloadProgressBar && <DownloadProgressBar />}
            {(state.const_var.isShowImage !== undefined && state.const_var.isShowImage !== -1) && <SlideImage/>}
            { state.isShowSpecification &&
                <div className='specification-wrap'>
                    <BuildingInformation />
                    <div className='popup-close'><span className='close'  onClick={(e)=> dispatch(ShowMobilePopUp("specification"))}>&times;</span></div>
                </div>
            }
            { state.isShowMobileBuildingSummary &&
                <div className='specification-wrap'>
                    <div className='mb-building-summary-header'>
                        <h2>Building Summary</h2>
                    </div>
                    <ProductSummary />
                    <div className='popup-close'><span className='close'  onClick={(e)=> dispatch(ShowMobilePopUp("buildingsummary"))}>&times;</span></div>
                </div>
            }
            
        </>
    )
}
export default Component;